import ApiService from "../../../commons/services/ApiService";
import CompanyAPI from "../../company/CompanyAPI";

const apiService = new ApiService();

export default class ExternalTransactionAPI {

    URI_V1 = "/v1/external-transactions"

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    update = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    delete = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };

    confirmSettlement = async (occurrenceId: any, data: any) => {
        return await apiService.patch(`${this.URI_V1}/ocurrence/${occurrenceId}/payment`, data);
    };

    deletePayment = async (occurrenceId: any) => {
        return await apiService.delete(`${this.URI_V1}/ocurrence/${occurrenceId}/payment`);
    };
    
    summarySum = async (filter: any) => {
        var query = `companyId=${new CompanyAPI().getCompanyManagment().id}`;
       
        if (filter.startDate) {
            query += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
        }

        if (filter.type) {
            query += `&type=${filter.type}`
        }

        return await apiService.get(`${this.URI_V1}/summary-sum?${query}`);
    };

    advancedSearch = async (id: any, filter: any) => {
        var query = `page=${filter.page}&limit=${filter.limit}&companyId=${new CompanyAPI().getCompanyManagment().id}`;
       
        if (filter.startDate) {
            query += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
        }

        if (filter.type) {
            query += `&type=${filter.type}`
        }

        if (id) {
            query += `&id=${id}`
        }

        return await apiService.get(`${this.URI_V1}/advanced-search?${query}`);
    };

}
